'use client'

import { Plus, Building2, Users, Edit, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { Switch } from '@/components/ui/switch'

export default function StoreManagement() {
  const stores = [
    { id: '1', store_code: 'STORE001', store_name: '강남점', status: 'active', use_robot_delivery: true, managers_count: 2, created_at: '2025-06-15' },
    { id: '2', store_code: 'STORE002', store_name: '판교점', status: 'active', use_robot_delivery: true, managers_count: 3, created_at: '2025-08-20' },
    { id: '3', store_code: 'STORE003', store_name: '홍대점', status: 'pending', use_robot_delivery: false, managers_count: 0, created_at: '2025-10-01' },
  ]

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle>점포 관리</CardTitle>
              <CardDescription>전체 {stores.length}개 점포</CardDescription>
            </div>
            <Button>
              <Plus className="h-4 w-4 mr-2" />
              새 점포 생성
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>점포명</TableHead>
                <TableHead>로봇배송</TableHead>
                <TableHead>상태</TableHead>
                <TableHead>관리자</TableHead>
                <TableHead>생성일</TableHead>
                <TableHead className="text-right">작업</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {stores.map(store => (
                <TableRow key={store.id}>
                  <TableCell className="font-medium">
                    <div className="flex items-center gap-2">
                      <Building2 className="h-4 w-4 text-muted-foreground" />
                      {store.store_name}
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center gap-2">
                      <Switch checked={store.use_robot_delivery} disabled />
                      <span className={store.use_robot_delivery ? 'text-green-600' : 'text-gray-400'}>
                        {store.use_robot_delivery ? '사용' : '미사용'}
                      </span>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Badge variant={store.status === 'active' ? 'default' : store.status === 'pending' ? 'outline' : 'destructive'}>
                      {store.status === 'active' ? '영업 중' : store.status === 'pending' ? '초대 대기' : '영업 정지'}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center gap-1">
                      <Users className="h-4 w-4 text-muted-foreground" />
                      {store.managers_count}
                    </div>
                  </TableCell>
                  <TableCell>{store.created_at}</TableCell>
                  <TableCell className="text-right">
                    <Button variant="ghost" size="icon">
                      <Edit className="h-4 w-4" />
                    </Button>
                    <Button variant="ghost" size="icon" className="text-red-500">
                      <Trash2 className="h-4 w-4" />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  )
}
